// API utility functions for V2 features
// Abstracted to allow easy swap between mock and real API endpoints

import { getAuth } from 'firebase/auth';

// API configuration - uses Create React App proxy (configured in package.json)
// The proxy forwards /api/* requests to http://localhost:5001/api/*
// Flow: Frontend (3000) -> CRA Proxy -> Backend Proxy (5001) -> Odikai API (8000)
const API_BASE = process.env.REACT_APP_API_BASE || '/api';
const USE_MOCK_API = process.env.REACT_APP_USE_MOCK_API === 'true' || false;

// Mock API storage (for development)
const mockApiStorage = {
  playbooks: new Map()
};

// Initialize mock storage - will be populated by initializeMockApi

/**
 * Get Firebase auth token for API requests
 * (Kept for potential future API calls)
 */
async function getAuthToken() {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('User not authenticated');
  }
  return await currentUser.getIdToken(true);
}

/**
 * Initialize mock API with playbook data
 * Call this when loading mock data to populate the mock storage
 */
export function initializeMockApi(playbooks) {
  if (USE_MOCK_API && playbooks) {
    mockApiStorage.playbooks.clear();
    playbooks.forEach(playbook => {
      mockApiStorage.playbooks.set(playbook.id, playbook);
    });
  }
}


